import {useForm} from 'vee-validate';

import useConfiguracionStore from '@/store/configuracion';

import { required } from "@validations";
import useConfiguracion from "./useConfiguracion";

export default function useFormConfiguracion(modelDialog = null){

    const r = useRouter();

    const {
      showAyuda,
      configuracion_id,
      tipos_biografias,
      biografia,
      initialValues,
      usuario,
      guardar,
      colaboradores,
      showFormColaborador,
      showFormPortada,
      agregarColaborador,
      agregarPortada,
      actualizarValores
    } = useConfiguracion();


  

    const { errors, handleSubmit, setErrors, defineField,setValues,resetForm } = useForm({
      initialValues,
      validationSchema: {
        tipo_biografia_id: required,
        // papel_id      : required,
        paginas: required,
        // paginas_cap      : required,
        titulo: required,
        sub_titulo: required,
        tono: required,
        narracion: required,
        extension_libro: required,
        participacion_tercero: required,
        nombre_autor: required,
        apellido_autor: required,
      },
    });

    const [tipo_biografia_id, tipo_biografia_attrs] = defineField(
      "tipo_biografia_id",
      { type: Number }
    );
    const [paginas, paginas_attrs] = defineField("paginas", { type: Number });
    const [nombre_autor, nombre_autor_attrs] = defineField("nombre_autor");
    const [apellido_autor, apellido_autor_attrs] = defineField("apellido_autor");
    const [titulo, titulo_attrs] = defineField("titulo");
    const [sub_titulo, sub_titulo_attrs] = defineField("sub_titulo");
    const [invitaciones, invitaciones_attrs] = defineField("invitaciones");
    const [tono, tono_attrs] = defineField("tono");
    const [narracion, narracion_attrs] = defineField("narracion");
    const [extension_libro, extension_libro_attrs] =
      defineField("extension_libro");
    const [participacion_tercero, participacion_tercero_attrs] = defineField(
      "participacion_tercero"
    );

    //[1 => Serio y Sobrio, 2 => Cercano y coloquial, 3 => Inspirador y Emotivo, 4 => Profesional y técnico, 5 => Con humor o Anécdotico]
    const optionsTono = ref([
      { value: 1, text: "Serio y Sobrio" },
      { value: 2, text: "Cercano y coloquial" },
      { value: 3, text: "Inspirador y Emotivo" },
      { value: 4, text: "Profesional y técnico" },
      { value: 5, text: "Con humor o Anécdotico" },
    ]);

    //[1 => 1ra persona, 2 => 3ra persona]
    const optionsNarracion = ref([
      { value: 1, text: "Primera persona (Recuerdo aquel dia cuando...)" },
      { value: 2, text: "Tercera persona (A ella le gustaban las...)" },
    ]);

    // [1 => Breve (hasta 40 páginas), 2 => Mediana (40-100 páginas), 3 => Completa (100-200 páginas), 4 => Extensa (más de 200 páginas)]
    const optionsExtension = ref([
      { value: 1, text: "Breve (hasta 40 páginas)" },
      { value: 2, text: "Mediana (40-100 páginas)" },
      { value: 3, text: "Completa (100-200 páginas)" },
      { value: 4, text: "Extensa (más de 200 páginas)" },
    ]);

    // [1 => Si, 2 => No, 3 => Aun no lo se]
    const optionsParticacion = ref([
      { value: 1, text: "Si" },
      { value: 2, text: "No" },
      { value: 3, text: "Aun no lo se" },
    ]);
    

  // methods
  const cerrarModel = () => {
    if(modelDialog && modelDialog.value) {
      modelDialog.value = false;
    }
  }

  const configurar =  handleSubmit((values) => {
    preguntar(
      {
        title: `¿Está seguro de ${
          initialValues.value.id
            ? "actualizar la configuración"
            : "iniciar la biografía con la configuración"
        } elegida?`,
        confirmButtonText: `Si, ${
          initialValues.value.id ? "Actualizar" : "Iniciar"
        } Biografía`,
        cancelButtonText: "No, Cancelar",
      },
      () => {
        guardar({
          ...values,
          cliente_id: usuario.value.id,
        })
          .then(({ result, configuracion }) => {
            if (result) {
              if (!initialValues.value.id) {
                preguntar(
                  {
                    title: "Biografía Iniciada",
                    text: "̉Deseo realizarle una entrevista para completar la información general de su Biografía. ¿Desea ir al módulo de entrevistas ahora?",
                    confirmButtonText: "Si",
                    cancelButtonText: "No, mas tarde",
                  },
                  () => {

                    toast.success("Se ha iniciado la Biografía con éxito");
                    // Realizar entrevista
                    r.push({
                      name: "biografia.entrevistas",
                      params: {
                        id: configuracion.biografia.id,
                      },
                    });

                   cerrarModel();

                  },
                  () => {
                    toast.success("Se ha iniciado la Biografía con éxito");
                    r.push({
                      name: "biografia.preview",
                      params: { id: configuracion.biografia.id ?? null },
                    });
                    cerrarModel();
                  }
                );
              } else {
                toast.success(
                  "Se ha actualizado con éxito la configuración de la Biografía"
                );
              }
            } else {
              toast.error(
                "No se pudo iniciar la Biografía con la configuración elegida"
              );
            }
          })
          .catch((e) => {
            console.log(e);
            if (e.response && e.response.status === 422) {
              setErrors(e.response.data.errors);
            }
          });
      }
    );
  })

  watch(() => initialValues.value.id, () => {
    setValues(initialValues.value);
  })

  const refetchForm = () => {
    // resetForm();
    // console.log(initialValues.value);
    // actualizarValores(setValues);
  }



  const invitacionEnviada = (inv) => {
    showFormColaborador.value = false;
    if(!inv) return;

    if(colaboradores.value.findIndex(c => c.id == inv.id) == -1) {
      colaboradores.value.push(inv);
    }

    // colaboradores.value.push(inv);
    if(invitaciones.value.findIndex(i => i.id == inv.id) == -1) {
      setTimeout(() => {
            invitaciones.value = [...invitaciones.value, inv.id];
      }, 1000);
      
    }

  }

  return {
    // state
    initialValues,
    optionsParticacion,
    optionsExtension,
    optionsNarracion,
    optionsTono,
    tipos_biografias,
    colaboradores,
    errors,
    showFormColaborador,
    configuracion_id,

    // Form
    tipo_biografia_id,
    tipo_biografia_attrs,
    paginas,
    paginas_attrs,
    titulo,
    titulo_attrs,
    sub_titulo,
    sub_titulo_attrs,
    participacion_tercero,
    participacion_tercero_attrs,
    tono,
    tono_attrs,
    narracion,
    narracion_attrs,
    extension_libro,
    extension_libro_attrs,
    invitaciones,
    invitaciones_attrs,
    nombre_autor,
    nombre_autor_attrs,
    apellido_autor,
    apellido_autor_attrs,

    //methods
    configurar,
    agregarColaborador,
    refetchForm,
    invitacionEnviada,
  };

}
